import { Error } from '@mui/icons-material';
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import {
  AddDetailParticipantDialog,
  CountdownTimer,
  EventInfoFragment,
  FormTextField,
  RaceOrRacepackInfo,
  RacepacksFragments,
  TicketSummaryDialog,
} from '..';
import { LoadingButton } from '@mui/lab';
import api from '../../services/apiClient';
// import { useGetEventInformationQuery } from '../../services/iracedb';
import { toCurrencyForm } from '../../utils/stringFormatter';
import CustomTabPanel, { a11lyProps } from '../CustomTabPanel/CustomTabPanel';
import classes from './style';
import prodigiLogo from '../../assets/Color horizontal.png';
import { generate } from '../../utils/generateToken';
import { useNavigate } from 'react-router-dom';

const CACHE_TTL_MS = 60_000; // 1 menit
const cacheKey = (id) => `offlane_event_${id}`;

function readCache(id) {
  try {
    const raw = localStorage.getItem(cacheKey(id));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null; // {ts, data}
    return parsed;
  } catch {
    return null;
  }
}

function writeCache(id, data) {
  try {
    localStorage.setItem(
      cacheKey(id),
      JSON.stringify({ ts: Date.now(), data }),
    );
  } catch {}
}

const diffTz = 0;
export const getTztime = (date) => {
  if (!date) return null;
  const tzTime = dayjs(date).subtract(diffTz, 'hours');
  return tzTime;
};

const OfflineEventInformation = ({ id }) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:600px)');
  const isTab = useMediaQuery('(max-width:1000px)');

  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [isOpenSummary, setIsOpenSummary] = useState(false);
  const [isBuyInsurance, setIsBuyInsurance] = useState(0);

  const [tabIdx, setTabIdx] = useState(0);
  const [dp, setDp] = useState();
  const [selectedCategory, setSelectedCategory] = useState();
  const [loadOrderAndGetSnapToken, setLoadOrderAndGetSnapToken] =
    useState(false);
  const [isFetchingCodeStatus, setIsFetchingCodeStatus] = useState(false);
  const [snapToken, setSnapToken] = useState('');
  const [chartUrl, setChartUrl] = useState();
  const [code, setCode] = useState({ value: '', errorMessage: '', data: {} });

  // checkbox & dialog peraturan (hanya berlaku untuk eventId 82)
  const [isTermsChecked, setIsTermsChecked] = useState(false);
  const [isTermsDialogOpen, setIsTermsDialogOpen] = useState(false);
  const [isTermsScrolledToBottom, setIsTermsScrolledToBottom] = useState(false);
  const termsContentRef = useRef(null);

  // get data from api
  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isTermsDialogOpen) return;

    setIsTermsScrolledToBottom(false);

    // tunggu layout kelar dulu
    requestAnimationFrame(() => {
      const el = termsContentRef.current;
      if (!el) return;

      // kalau konten TIDAK lebih tinggi dari container → tidak perlu scroll
      if (el.scrollHeight <= el.clientHeight + 1) {
        setIsTermsScrolledToBottom(true);
      }
    });
  }, [isTermsDialogOpen]);

  useEffect(() => {
    const getOfflaneEventInformation = async () => {
      setIsFetching(true);
      setError(null);

      try {
        const response = await api.get(`/home/offline/event/${id}`);
        // console.log(response.data);
        setData(response.data);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setIsFetching(false);
      }
    };

    getOfflaneEventInformation();
  }, [id]);

  // hanya eventId 82 yang wajib baca peraturan
  const isTermsRequired =
    parseInt(data?.info?.eventId) === 82 ||
    parseInt(data?.info?.eventId) === 84 ||
    parseInt(data?.info?.eventId) === 87;

  useEffect(() => {
    if (snapToken === '') return;
    window.location.href = snapToken;
  }, [snapToken]);

  useEffect(() => {
    getSizeChartUrl();
  }, [data?.racepacks]);

  //#region function
  const getSizeChartUrl = () => {
    if (!data?.racepacks?.length === 0) return;

    const sizeChart = data?.racepacks?.find((rcp) =>
      rcp.name.includes('Chart'),
    );

    setChartUrl(sizeChart?.image);
  };

  //#region handle code
  const handleCodeDataChange = (key, item) => {
    const updated = { ...code };
    updated[key] = item;
    setCode(updated);
  };
  //#endregion

  // dialog peraturan
  const openTermsDialog = () => {
    setIsTermsDialogOpen(true);
  };

  const handleTermsScroll = (event) => {
    const target = event.currentTarget;
    if (target.scrollTop + target.clientHeight >= target.scrollHeight - 8) {
      setIsTermsScrolledToBottom(true);
    }
  };

  const handleTermsAgree = () => {
    setIsTermsChecked(true);
    setIsTermsDialogOpen(false);
  };

  const handleJoinEvent = async () => {
    try {
      // wajib centang terms hanya jika eventId = 82
      if (isTermsRequired && !isTermsChecked) {
        alert(
          'Silakan baca dan setujui peraturan terlebih dahulu sebelum join event.',
        );
        return;
      }

      if (code.value === '') return alert('Input Code.');
      setIsFetchingCodeStatus(true);

      const { data: couponData } = await api.get(
        `/coupon/validate/${data?.info?.eventId}/${code.value}/${selectedCategory?.categoryId}`,
      );

      setIsFetchingCodeStatus(false);

      handleCodeDataChange('data', couponData);

      const params = {
        eventId: data?.info?.eventId,
        category: {
          race_category: selectedCategory.categoryId,
          name: selectedCategory.name,
          minAge: selectedCategory.adultMinAge,
          maxAllowedDate: selectedCategory.maxAllowedDate,
          adultSizeIndex: selectedCategory.adultSizeIndex,
          endReg: selectedCategory.endDate,
        },
        coupon: {
          voucher: couponData?.code,
          id: couponData?.coupon_id,
        },
      };

      if (parseInt(data?.info?.eventId) === 76) {
        const urlParams = generate(JSON.stringify(params));
        navigate(`/event/register/${urlParams}`);
        return;
      }

      setIsOpenDialog(true);
    } catch (error) {
      setIsFetchingCodeStatus(false);
      alert(error.response?.data || error.message);
    }
  };

  const handleOnChange = (event) => {
    const categoryFind = data?.categories?.find(
      (cat) => cat.categoryId.toString() === event.target.value.toString(),
    );
    setSelectedCategory(categoryFind);
    // ganti kategori → reset checkbox terms
    setIsTermsChecked(false);
  };

  const handleTabChange = (event, newValue) => {
    setTabIdx(newValue);
  };

  const handleGoToSummary = ({ email, team, participants, emergency }) => {
    const updated = { ...dp };
    updated.order = {
      email: { value: email.email.value },
      orderType: { value: 'web' },
      bill: { value: 0 },
    };

    updated.team = team;
    updated.participants = participants;
    updated.emergency = emergency;

    setDp(updated);
    setIsOpenDialog((prev) => !prev);
    setSnapToken('');

    setTimeout(() => {
      setIsOpenSummary((prev) => !prev);
    }, 200);
  };

  const handleChoosePayment = async ({ bill, coupon }) => {
    if (parseInt(bill) === 0) return registerOfflineEvent({ bill, coupon });

    if (loadOrderAndGetSnapToken) return;
    if (snapToken !== '') return;

    setLoadOrderAndGetSnapToken(true);

    const params = { ...dp };
    params.order.bill.value = bill;

    const participantUpdated = params.participants.map((p) => {
      const localDateString = dayjs(p.birthDate.value).format('MM/DD/YYYY');
      return {
        ...p,
        birthDate: localDateString,
      };
    });
    params.participants = participantUpdated;

    const cp = code?.data?.coupon_id ? code : coupon;

    const apiPayload = {
      event: data?.info,
      category: selectedCategory,
      coupon: {
        id: cp?.data?.coupon_id,
        code: cp?.data?.code,
      },
      insurance: data?.info?.isInsuranceBundled > 0 ? 1 : isBuyInsurance,
      ...params,
    };

    try {
      const result = await api.post(
        process.env.REACT_APP_OFFLINE_PAY,
        apiPayload,
      );

      setSnapToken(result.data?.url);
    } catch (error) {
      setLoadOrderAndGetSnapToken(false);
      setSnapToken('');
      alert(JSON.stringify(error.response?.data || error.message));
    }
  };

  const registerOfflineEvent = async ({ bill, coupon }) => {
    const params = { ...dp };
    params.order.bill.value = bill;

    const participantUpdated = params.participants.map((p) => {
      const localDateString = dayjs(p.birthDate.value).format('MM/DD/YYYY');
      return {
        ...p,
        birthDate: localDateString,
      };
    });
    params.participants = participantUpdated;

    const cp = code?.data?.coupon_id ? code : coupon;

    const regParams = {
      event: data?.info,
      category: selectedCategory,
      coupon: {
        id: cp?.data?.coupon_id,
        code: cp?.data?.code,
      },
      ...params,
    };

    setLoadOrderAndGetSnapToken(true);

    try {
      await api.post(process.env.REACT_APP_OFFLINE_FREE, regParams);

      alert(`Registration Complete, E-ticket will be sent via email`);

      if (parseInt(data?.info?.eventId) !== 81) window.location = '/';
      setTimeout(() => {
        setLoadOrderAndGetSnapToken(false);
        setIsOpenDialog(false);
        setIsOpenSummary(false);
      }, 150);
    } catch (error) {
      setLoadOrderAndGetSnapToken(false);
      alert(JSON.stringify(error.response?.data || error.message));
    }
  };

  const getRemainingSlotText = (item) => {
    if (!item) return '-';

    const limit = parseInt(item.priceLimit);
    const priceCount =
      parseInt(item.pricePending) + parseInt(item.priceSuccess);
    const resultCount = limit - priceCount;

    if (resultCount > 0) {
      const dividerNumber =
        parseInt(item.adultsLimit) +
        parseInt(item.kidsLimit) +
        parseInt(item.participantLimit);

      return resultCount / dividerNumber;
    } else {
      const pending = parseInt(item.pricePending);
      if (pending > 0) return 'Full';
      return 'Sold Out!';
    }
  };

  const checkSlotLimit = (item) => {
    if (!item) return;

    const limit = parseInt(item.priceLimit);
    const priceCount =
      parseInt(item.pricePending) + parseInt(item.priceSuccess);
    const resultCount = limit - priceCount;

    if (resultCount > 0) {
      return true;
    } else {
      const pending = parseInt(item.pricePending);
      if (pending > 0) alert('Slot Full, please try again later');
      else alert('Ticket Sold Out!');

      return false;
    }
  };

  const joinEvent = (item) => {
    // wajib centang terms hanya jika eventId = 82
    if (isTermsRequired && !isTermsChecked) {
      alert(
        'Silakan baca dan setujui peraturan terlebih dahulu sebelum join event.',
      );
      return;
    }

    const valid = checkSlotLimit(item);
    if (valid === false) return;

    setIsOpenDialog((prev) => !prev);
  };
  //#endregion

  //#region loading and error view
  if (isFetching)
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mt: { xs: 8, sm: 5 },
        }}
      >
        <CircularProgress size="4rem" />
      </Box>
    );

  if (error)
    return (
      <Box
        display={'flex'}
        flexGrow={1}
        flex={1}
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'column'}
        sx={{ height: '500px' }}
      >
        <Error sx={{ fontSize: '64px', color: '#afafaf' }} />
        <Typography sx={{ color: '#afafaf' }} variant="h3">
          {error.message.toUpperCase()}
        </Typography>
      </Box>
    );
  //#endregion

  return (
    <>
      <Grid
        container
        style={classes.containerSpaceAround}
        sx={{
          flexDirection: { xs: 'column', lg: 'row' },
          flexWrap: { xs: 'wrap', sm: 'inherit' },
          mt: { xs: 3, sm: 5, xl: 8 },
        }}
      >
        {/* image */}
        <Grid item sm={12} lg={5} style={classes.bannerContainer}>
          <img
            src={data?.info?.banner}
            alt={data?.info?.name}
            style={
              isMobile
                ? classes.bannerMobile
                : isTab
                  ? classes.bannerMedium
                  : classes.banner
            }
          />
        </Grid>
        {/* event detail information container */}
        <Grid
          item
          container
          lg={7}
          sx={{
            marginTop: { xs: '0', sm: '2rem', lg: '0' },
            paddingInline: { xs: '2em', sm: '0' },
            paddingBottom: { xs: '' },
          }}
        >
          {/* event information detail */}
          <Grid item xs={12} sm={6}>
            <div
              style={{
                display: 'flex',
                flexGrow: 1,
                flexDirection: 'column',
                marginTop: isMobile ? '10px' : '0',
              }}
            >
              {/* event info -- start */}
              <Typography variant={!isMobile ? 'h4' : 'h6'} fontWeight={'600'}>
                {data?.info?.name}
              </Typography>
              <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs
                    value={tabIdx}
                    onChange={handleTabChange}
                    aria-label="basic tabs example"
                  >
                    <Tab label="Details" {...a11lyProps(0)} />
                    <Tab label="Racepacks" {...a11lyProps(1)} />
                    {data?.info?.containInsurance && (
                      <Tab label="Insurance" {...a11lyProps(2)} />
                    )}
                  </Tabs>
                </Box>
                <CustomTabPanel value={tabIdx} index={0}>
                  {/* event info -- end */}
                  <Box>
                    <RaceOrRacepackInfo
                      isMobile={isMobile}
                      label={'Race Info'}
                      location={data?.info?.eventLocation}
                      start={data?.info?.startDate}
                      end={data?.info?.endDate}
                    />
                  </Box>
                  {/* racepack info -- start */}
                  {id && id !== 79 && id !== 80 && (
                    <Box>
                      <RaceOrRacepackInfo
                        isMobile={isMobile}
                        label={'Racepack Collection Info'}
                        location={data?.info?.racepackCollection}
                        start={data?.info?.startRacepackCollectionDate}
                        end={data?.info?.endRacepackCollectionDate}
                        isRacepack
                      />
                    </Box>
                  )}
                  {/* description */}
                  <Box>
                    <EventInfoFragment
                      isMobile={isMobile}
                      label={'Description'}
                      body={data?.info?.description}
                    />
                  </Box>

                  <Box>
                    <EventInfoFragment
                      isMobile={isMobile}
                      label={'Race Organizer'}
                      body={data?.info?.organizer || '-'}
                    />
                  </Box>

                  <Box>
                    <EventInfoFragment
                      isMobile={isMobile}
                      label={'Race Management'}
                      body={data?.info?.raceManagement || '-'}
                    />
                  </Box>

                  <Box>
                    <EventInfoFragment
                      isMobile={isMobile}
                      label={'Timing System'}
                      body={data?.info?.timingSystem || '-'}
                    />
                  </Box>
                </CustomTabPanel>
                <CustomTabPanel value={tabIdx} index={1}>
                  <RacepacksFragments racepacks={data?.racepacks} />
                </CustomTabPanel>
                {data?.info?.containInsurance > 0 && (
                  <CustomTabPanel value={tabIdx} index={2}>
                    <Paper
                      style={{
                        maxHeight: '720px',
                        overflowY: 'scroll',
                        padding: '8px',
                      }}
                    >
                      <EventInfoFragment
                        isMobile={isMobile}
                        label={'Asuransi di dukung oleh:'}
                        body={
                          <img
                            src={prodigiLogo}
                            alt="prodigi"
                            style={{ width: '200px' }}
                          />
                        }
                      />
                      <EventInfoFragment
                        isMobile={isMobile}
                        label={'Nama Produk Asuransi'}
                        body={'Asuransi Kecelakaan Diri'}
                      />
                      <EventInfoFragment
                        isMobile={isMobile}
                        label={'Manfaat'}
                        body={
                          <div>
                            1. Meninggal dunia akibat Kecelakaan IDR 50.000.000{' '}
                            <br />
                            2. Biaya Ketidakmampuan (Cacat) IDR 50.000.000{' '}
                            <br />
                            3. Biaya Pengobatan (termasuk biaya pengobatan
                            alternatif - shinshe berlisensi) IDR 5.000.000
                          </div>
                        }
                      />
                      <EventInfoFragment
                        isMobile={isMobile}
                        label={'Jaminan Asuransi'}
                        body={
                          <div>
                            1. Meninggal Dunia Akibat Kecelakaan: Memberikan
                            santunan jika Tertanggung mengalami kecelakaan
                            selama masa pertanggungan asuransi yang menyebabkan
                            kematian. Kecelakaan yang dimaksud adalah semua
                            kejadian yang setara dengan kecelakaan itu sendiri.{' '}
                            <br />
                            2. Penggantian Biaya Ketidakmampuan Akibat
                            Kecelakaan saat Olahraga Memberikan santunan jika
                            Tertanggung Ketika mengalami cacat sebagai akibat
                            dari Kecelakaan saat melakukan aktivitas olahraga.{' '}
                            <br />
                            3. Penggantian Biaya Pengobatan Akibat Kecelakaan
                            saat Olahraga: Memberikan penggantian biaya
                            pengobatan jika Tertanggung mengalami kecelakaan
                            saat melakukan aktifitas olahraga selama masa
                            pertanggungan asuransi yang menyebabkan tertanggung
                            menjalani perawatan kesehatan di rumah sakit atau
                            klinik yang memiliki izin rawat inap. Kecelakaan
                            yang dimaksud adalah semua kejadian yang setara
                            dengan kecelakaan itu sendiri dan tidak harus
                            menyebabkan kematian atau cacat tetap. <br />
                            4. Penggantian Biaya Pengobatan Alternatif (Sinshe
                            Berlisensi): Memberikan penggantian Biaya Perawatan
                            atau Pengobatan Alternatif atas kuitansi yang
                            dikeluarkan oleh pengobatan alternatif (sinshe) yang
                            berizin sebesar batas manfaat yang tercantum dalam
                            polis akibat kecelakaan yang terjadi selama masa
                            pertanggungan. Ketentuan perawatan atau pengobatan
                            alternatif harus dilakukan pada hari yang sama
                            terjadinya kecelakaan yang dijamin di dalam polis
                            dan klaim perawatan atau pengobatan alternatif harus
                            disertai dengan foto luka badan luar yang dialami
                            Tertanggung.
                          </div>
                        }
                      />
                      <EventInfoFragment
                        isMobile={isMobile}
                        label={'Batas Pertanggungan'}
                        body={
                          <div>
                            Ketentuan besarnya penggantian maupun santunan
                            untuk:
                            <br />
                            1. Selain manfaat Kematian, semua manfaat lainnya
                            dapat diklaim lebih dari 1(satu) kali selama masa
                            pertanggungan dan selama batas santunan masih
                            tersedia. <br />
                            2. Besarnya penggantian risiko Kematian dan Cacat
                            Tetap (sesuai prosentase kecacatan) diberikan sesuai
                            plan yang diambil. <br />
                            3. Penggantian risiko biaya Pengobatan di Rumah
                            Sakit bersifat total sesuai dengan plan yang diambil
                            dan menunjukkan bukti-bukti pengobatan/perawatan
                            yang sah/asli atau dilegalisir bila yang asli
                            dipergunakan untuk pengajuan klaim lainnya.
                          </div>
                        }
                      />
                      <EventInfoFragment
                        isMobile={isMobile}
                        label={'Metode Klaim'}
                        body={'Santunan / Tebusan (Reimbursement).'}
                      />
                      <EventInfoFragment
                        isMobile={isMobile}
                        label={'Kriteria Kelayakan Calon Tertanggung'}
                        body={
                          <div>
                            1. Kewarganegaraan: Warga Negara Indonesia dan Warga
                            Negara Asing yang memiliki izin tinggal di
                            Indonesia.
                            <br />
                            2. Usia: 12 tahun – 70 tahun
                          </div>
                        }
                      />
                      <EventInfoFragment
                        isMobile={isMobile}
                        label={'Syarat & Ketentuan'}
                        body={
                          <div>
                            Pengecualian Umum: <br />
                            A. Perang (dengan atau tanpa adanya pernyataan
                            perang), pemogokan kerja atau larangan bekerja,
                            kerusuhan atau huru-hara, pemberontakan, perang
                            saudara, invasi atau kegiatan perang yang serupa;{' '}
                            <br />
                            B. Terorisme yang melibatkan penggunaan bahan
                            nuklir, biologis atau kimiawi; <br />
                            C. Keterlibatan Tertanggung dalam komando atau tugas
                            / pelatihan penjinak bom, tugas militer seperti
                            menjaga ketertiban sipil, permusuhan dan perjalanan
                            dengan pesawat militer atau kapal yang dikemudikan
                            di dalam air;
                            <br />
                            D. Radiasi atau kontaminasi radioaktif; <br />
                            E. Bencana alam;
                            <br />
                            F. Tertanggung secara sengaja menggunakan alkohol
                            atau obat-obatan, bunuh diri atau upaya bunuh diri
                            atau upaya melukai diri sendiri baik dalam keadaan
                            sadar atau tidak sadar; <br />
                            G. Keterlibatan Tertanggung dalam tindakan melanggar
                            hukum, tangan keadilan atau paparan disengaja untuk
                            bahaya yang tidak diperlukan, kecuali dalam upaya
                            untuk menyelamatkan manusia; <br />
                            H. Setiap cedera atau Patah Tulang berkelanjutan
                            akibat Tertanggung sedang melakukan atau mencoba
                            untuk melakukan suatu tindak kejahatan atau menolak
                            penangkapan oleh petugas penegak hukum; <br />
                            I. Penyakit mental dan gangguan mental lainnya serta
                            kelainan bawaan dari lahir; <br />
                            J. Kehamilan atau persalinan dan komplikasinya;{' '}
                            <br />
                            K. Keterlibatan Tertanggung dalam segala jenis
                            penerbangan selain sebagai seorang penumpang yang
                            membayar di dalam penerbangan terbang yang terjadwal
                            dengan rutin yang disediakan dan dioperasikan oleh
                            suatu perusahaan penerbangan komersial; <br />
                            L. Kecelakaan sebagai akibat melakukan, mencoba atau
                            memprovokasi serangan; atau
                            <br />
                            M. Kecelakaan yang terjadi saat Tertanggung
                            melakukan pekerjaan seharihari yang merupakan satu
                            atau beberapa dari daftar di bawah: <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a. Di atas
                            ketinggian 15 meter;
                            <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;b. Bekerja di
                            tambang bawah tanah; <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;c. Diperlukan
                            membawa senjata api atau peledak; <br />
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;d.Bekerja lepas
                            pantai pada perusahaan gas, minyak bumi atau
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;bensin
                            <br />
                            N.Pengecualian lain sesuai pengecualian standar
                            PSAKDI 2016.
                          </div>
                        }
                      />
                      <EventInfoFragment
                        isMobile={isMobile}
                        label={'Penanganan Klaim'}
                        body={
                          <div>
                            1. Pelaporan Klaim: <br />
                            &nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Manfaat
                            Meninggal Dunia: Maks. 60 (enam-puluh) hari kalendar
                            sejak tanggal kejadian. <br />
                            &nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Selain Meninggal
                            Dunia: Maks. 30 (tiga-puluh) hari calendar tanggal
                            kejadian <br />
                            2. Pelengkapan Dokumen Klaim: <br />
                            &nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Manfaat
                            Meninggal Dunia: Maks. 30 (tiga-puluh) hari kalendar
                            sejak tanggal Pelaporan. <br />
                            &nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Selain Meninggal
                            Dunia: Maks. 14 (empat-belas) hari kalendar tanggal
                            Pelaporan. <br />
                            3. Penilaian Klaim & Akseptasi: <br />
                            &nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Manfaat
                            Meninggal Dunia: Maks. 5 (lima) hari kerja sejak
                            dokumen lengkap diterima. <br />
                            &nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Selain Meninggal
                            Dunia: Maks. 3 (tiga) hari kerja sejak dokumen
                            lengkap diterima. <br />
                            4. Pembayaran Manfaat Klaim: <br />
                            &nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Manfaat
                            Meninggal Dunia: Maks. 5 (lima) hari kerja sejak
                            dari tanggal Letter of Discharge (LoD) diterima dari
                            Tertanggung.
                            <br />
                            &nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;Selain Meninggal
                            Dunia: Maks. 3 (tiga) hari kerja sejak dari tanggal
                            Letter of Discharge (LoD) diterima dari Tertanggung.
                          </div>
                        }
                      />
                      <EventInfoFragment
                        isMobile={isMobile}
                        label={'Cara Klaim'}
                        body={
                          <div>
                            1. Pelaporan Klaim dari Tertanggung dilakukan
                            melalui :
                            <p>Akses url: https://polis.prodiginow.com</p>
                            <p>Atau</p>
                            <p>
                              Menghubungi Claim Hotline : 150118 tekan 2 WA
                              Claim : +6281280489167 Jam Kerja: Senin - Jumat
                              (08.00 - 17.00 WIB) Email : claim@prodiginow.com
                            </p>
                            2. Semua dokumen klaim dalam format digital (photo),
                            termasuk LOD yang ditandatangani oleh Tertanggung
                          </div>
                        }
                      />
                    </Paper>
                  </CustomTabPanel>
                )}
              </Box>
            </div>
          </Grid>

          {/* choose category */}
          <Grid item xs={12} sm={6}>
            <div
              style={{
                display: 'flex',
                marginLeft: isMobile ? '0' : '1rem',
                marginTop: isMobile ? '10px' : '0',
              }}
            >
              <Box
                display={'flex'}
                justifyContent={'flex-start'}
                marginBottom={'10px'}
                flexDirection={'column'}
                borderRadius={'14px'}
                padding={'10px 16px'}
                flex={1}
                sx={{
                  border: 3,
                  borderColor: 'grey.200',
                }}
              >
                {data?.info?.startRegistrationDate &&
                  dayjs().unix() <
                    getTztime(data?.info?.startRegistrationDate).unix() && (
                    <CountdownTimer
                      openRegDate={getTztime(data?.info?.startRegistrationDate)}
                    />
                  )}

                {data?.info?.endRegistrationDate &&
                  dayjs().unix() >
                    getTztime(data?.info?.endRegistrationDate).unix() && (
                    <Typography variant="h4" color={'GrayText'}>
                      Registration Already Closed.
                    </Typography>
                  )}

                {data?.info?.startRegistrationDate &&
                dayjs().unix() >=
                  getTztime(data?.info?.startRegistrationDate).unix() &&
                dayjs().unix() <=
                  getTztime(data?.info?.endRegistrationDate).unix() ? (
                  <FormControl>
                    <FormLabel id="choose-category-form">
                      Choose Your Category
                    </FormLabel>
                    <RadioGroup
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="choose-category-form"
                      value={selectedCategory?.categoryId}
                      onChange={handleOnChange}
                    >
                      {data?.categories?.map((category, idx) => (
                        <FormControlLabel
                          key={idx}
                          value={category?.categoryId}
                          control={<Radio />}
                          label={category?.name}
                        />
                      ))}
                    </RadioGroup>
                    {selectedCategory && (
                      <>
                        {data?.info?.isInternal === 0 && (
                          <Box display={'flex'} flexDirection={'column'}>
                            <Divider style={{ marginBottom: '4px' }} />
                            <Box display={'flex'} flexDirection={'row'}>
                              <Box
                                display={'flex'}
                                flexGrow={1}
                                flexDirection={'column'}
                              >
                                <Typography variant="body1" fontWeight={'600'}>
                                  Registration Fee
                                </Typography>
                                <Typography variant="body1">
                                  {selectedCategory?.registrationFee === '0'
                                    ? 'FREE'
                                    : `Rp
                                    ${toCurrencyForm(
                                      selectedCategory?.registrationFee,
                                    )}`}
                                </Typography>
                              </Box>
                              <Box
                                display={'flex'}
                                flexGrow={1}
                                flexDirection={'column'}
                              >
                                <Typography variant="body1" fontWeight={'600'}>
                                  Price Group
                                </Typography>
                                <Typography variant="body1">
                                  {selectedCategory?.priceLabel}
                                </Typography>
                              </Box>
                              {data.info && (
                                <Box
                                  display={'flex'}
                                  flexGrow={1}
                                  flexDirection={'column'}
                                >
                                  <Typography
                                    variant="body1"
                                    fontWeight={'600'}
                                  >
                                    Slot
                                  </Typography>
                                  <Typography variant="body1">
                                    {getRemainingSlotText(selectedCategory)}
                                  </Typography>
                                </Box>
                              )}
                            </Box>

                            {/* checkbox peraturan (hanya jika eventId = 82) */}
                            {isTermsRequired && (
                              <Box mt={1}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={isTermsChecked}
                                      onChange={(e) =>
                                        setIsTermsChecked(e.target.checked)
                                      }
                                    />
                                  }
                                  label={
                                    <Typography variant="body2">
                                      Saya telah membaca dan menyetujui
                                      peraturan yang telah ditentukan.{' '}
                                      <Box
                                        component="span"
                                        sx={{
                                          color: 'error.main',
                                          textDecoration: 'underline',
                                          cursor: 'pointer',
                                        }}
                                        onClick={openTermsDialog}
                                      >
                                        Lihat peraturan
                                      </Box>
                                    </Typography>
                                  }
                                />
                              </Box>
                            )}

                            <Button
                              variant="contained"
                              style={{ marginTop: '10px' }}
                              onClick={() => joinEvent(selectedCategory)}
                            >
                              Join Event!
                            </Button>
                          </Box>
                        )}
                        {data?.info?.isInternal > 0 && (
                          <Box display={'flex'} flexDirection={'column'}>
                            <Divider style={{ marginBottom: '4px' }} />
                            <Box
                              display={'flex'}
                              flexDirection={'row'}
                              marginBottom={'20px'}
                            >
                              <Box
                                display={'flex'}
                                flexGrow={1}
                                flexDirection={'column'}
                              >
                                <Typography variant="body1" fontWeight={'600'}>
                                  RegistrationFee
                                </Typography>
                                <Typography variant="body1">
                                  {selectedCategory?.registrationFee === '0'
                                    ? 'FREE'
                                    : `Rp
                                    ${toCurrencyForm(
                                      selectedCategory?.registrationFee,
                                    )}`}
                                </Typography>
                              </Box>
                              <Box
                                display={'flex'}
                                flexGrow={1}
                                flexDirection={'column'}
                              >
                                <Typography variant="body1" fontWeight={'600'}>
                                  Price Group
                                </Typography>
                                <Typography variant="body1">
                                  {selectedCategory?.priceLabel}
                                </Typography>
                              </Box>
                              {data.info?.eventId !== 84 &&
                                data.info?.eventId !== 87 && (
                                  <Box
                                    display={'flex'}
                                    flexGrow={1}
                                    flexDirection={'column'}
                                  >
                                    <Typography
                                      variant="body1"
                                      fontWeight={'600'}
                                    >
                                      Slot
                                    </Typography>
                                    <Typography variant="body1">
                                      {getRemainingSlotText(selectedCategory)}
                                    </Typography>
                                  </Box>
                                )}
                            </Box>

                            <FormTextField
                              index={1}
                              i={0}
                              required
                              label={'Code'}
                              errorMessage={code.errorMessage}
                              value={code.value}
                              onChange={(e) =>
                                handleCodeDataChange('value', e.target.value)
                              }
                            />

                            {/* checkbox peraturan (hanya jika eventId = 82) */}
                            {isTermsRequired && (
                              <Box mb={1}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={isTermsChecked}
                                      onChange={(e) =>
                                        setIsTermsChecked(e.target.checked)
                                      }
                                    />
                                  }
                                  label={
                                    <Typography variant="body2">
                                      Saya telah membaca dan menyetujui
                                      peraturan yang telah ditentukan.{' '}
                                      <Box
                                        component="span"
                                        sx={{
                                          color: 'error.main',
                                          textDecoration: 'underline',
                                          cursor: 'pointer',
                                        }}
                                        onClick={openTermsDialog}
                                      >
                                        Lihat peraturan
                                      </Box>
                                    </Typography>
                                  }
                                />
                              </Box>
                            )}

                            <LoadingButton
                              variant="contained"
                              onClick={handleJoinEvent}
                              loading={isFetchingCodeStatus}
                            >
                              Join Event!
                            </LoadingButton>
                          </Box>
                        )}
                      </>
                    )}
                  </FormControl>
                ) : null}
              </Box>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <AddDetailParticipantDialog
        eventId={data?.info?.eventId}
        showDialog={isOpenDialog}
        closeDialog={() => setIsOpenDialog((prev) => !prev)}
        categoryId={selectedCategory?.categoryId}
        kidsLimit={selectedCategory?.kidsLimit}
        kidMaxAge={selectedCategory?.kidMaxAge}
        kidSizeRange={selectedCategory?.kidSizeIndex}
        adultsLimit={selectedCategory?.adultsLimit}
        adultMinAge={selectedCategory?.adultMinAge}
        adultMaxAge={selectedCategory?.adultMaxAge}
        maxAllowedDate={selectedCategory?.maxAllowedDate}
        adultSizeRange={selectedCategory?.adultSizeIndex}
        participantLimit={selectedCategory?.participantLimit}
        includeJersey={selectedCategory?.includeJersey}
        isAllSos={selectedCategory?.isAllSos}
        isGroup={selectedCategory?.isGroup}
        goToSummary={handleGoToSummary}
        sizeChartUrl={chartUrl}
        sizesInfo={data?.sizesInfo}
      />
      <TicketSummaryDialog
        showSummary={isOpenSummary}
        onClose={() => setIsOpenSummary((prev) => !prev)}
        event={data?.info}
        team={dp?.team}
        participants={dp?.participants}
        emergency={dp?.emergency}
        category={selectedCategory}
        internalCode={code?.data}
        order={dp?.order}
        onChoosePayment={handleChoosePayment}
        isLoading={loadOrderAndGetSnapToken}
      />

      {/* Dialog Peraturan */}
      <Dialog
        open={isTermsDialogOpen}
        onClose={(event, reason) => {
          // nggak bisa ditutup pakai backdrop atau ESC
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
        }}
        fullWidth
        maxWidth="sm"
        disableEscapeKeyDown
      >
        <DialogTitle>Peraturan Lomba</DialogTitle>
        <DialogContent
          dividers
          sx={{ maxHeight: 400, overflowY: 'auto' }}
          onScroll={handleTermsScroll}
          ref={termsContentRef}
        >
          {/* TODO: ganti isi ini pakai data dari backend kalau ada, misal data?.info?.rules */}
          <Typography variant="body2" paragraph>
            Isi peraturan lomba ditampilkan di sini. Scroll sampai bawah untuk
            mengaktifkan tombol Agree.
          </Typography>
          <Typography variant="body2" paragraph>
            1. Peserta wajib mematuhi seluruh aturan lomba yang ditetapkan oleh
            panitia.
          </Typography>
          <Typography variant="body2" paragraph>
            2. Panitia berhak mendiskualifikasi peserta yang melanggar aturan
            tanpa pengembalian biaya pendaftaran.
          </Typography>
          <Typography variant="body2" paragraph>
            3. Keputusan panitia bersifat final dan tidak dapat diganggu gugat.
          </Typography>
          <Typography variant="body2" paragraph>
            4. Dengan mengikuti lomba ini, peserta menyatakan telah membaca,
            memahami, dan menyetujui seluruh peraturan.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={handleTermsAgree}
            disabled={!isTermsScrolledToBottom}
          >
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default OfflineEventInformation;
